module.exports = __webpack_public_path__ + "static/media/Box-with-pin.b7449d67.png";